module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-5-75d61b0037cbceb83deaff7cb081adb4.jpg";